var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"set_Lan"},[(_vm.isShow)?_c('div',{staticClass:"cont",on:{"click":_vm.open}},[_c('div',{staticClass:"span"},[_vm._v(_vm._s(_vm.language))]),_c('van-icon',{staticClass:"icon",attrs:{"name":"arrow-down"}})],1):_vm._e(),_c('PopModel',{ref:"popRef",attrs:{"list":_vm.lans},on:{"submit":_vm.setLan}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }